module.exports = __webpack_public_path__ + "media/images/vp/icon.tt.white-2a1eecc289a3779afd3279113459c252.png";